import React, { Fragment, useEffect, useState } from "react";
// import { withRouter } from "react-router-dom";
import { bool } from "prop-types";
import { connect, useDispatch } from "react-redux";
import { goBack, push } from "connected-react-router";
import * as i18n from "util/i18n";
import gaEventTracker, { events } from "util/gaEventTracker";
import { selectors as onboardingSelectors, actions as onboardingActions } from "reducers/onboarding";
import Notification from "pages/_components/Notification";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import CustomText from "pages/_components/CustomText/CustomText";
import InfoModal from "pages/_components/InfoModal";
import { ResponsiveHeader } from "pages/_components/header";

const StepStart = ({ isMobile, onboardingWithInvitation, onboardingWithEnrolledUser }) => {
    const dispatch = useDispatch();

    const [displayModal, setDisplayModal] = useState(false);

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    useEffect(() => {
        if (!onboardingWithInvitation) {
            dispatch(onboardingActions.setOnboardingWithEnrolledUser(false));
            setTimeout(() => {
                setDisplayModal(true);
            }, 1500);
        }
    }, []);

    const onStart = () => {
        if (onboardingWithInvitation) {
            dispatch(push("/onboarding/StepSmsWithInvitation"));
        } else {
            gaEventTracker.triggerEvent(events.registry1);
            dispatch(push("/onboarding/StepCUIT"));
        }
    };

    const onStartWithEnrolledUser = () => {
        dispatch(onboardingActions.setOnboardingWithEnrolledUser(true));
        dispatch(push("/onboarding/stepStartEnrolledUser"));
    };

    const onCloseModal = () => {
        dispatch(onboardingActions.setOnboardingWithEnrolledUser(false));
        setDisplayModal(false);
    };

    const createBodyModal = () => (
        <>
            <div className="text-center mb-5">{i18n.get("", 'Hacé click en "Continuar" si es tu primer ingreso')}</div>
            <Button
                bsStyle="primary"
                label="global.continue"
                loading={false}
                onClick={onCloseModal}
                id="save-code-button"
            />
            <Button
                bsStyle="link"
                label="onboarding.enrolled.user"
                loading={false}
                onClick={onStartWithEnrolledUser}
                id="save-code-button"
            />
        </>
    );

    return (
        <Fragment>
            <Notification scopeToShow="login" />
            {isMobile && (
                <ResponsiveHeader
                    ticket
                    id={i18n.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                    onClickBack={isMobile && onHeaderBack}
                />
            )}
            <MainContainer className="onboarding step-start">
                <h1 className="text-center">
                    <CustomText text={i18n.get("", "Antes de comenzar...")} />
                </h1>
                {displayModal && (
                    <InfoModal
                        noAcceptButton
                        noCancelButton
                        bodyInfoText="texto"
                        useScroll
                        body={createBodyModal}
                        onClick={onCloseModal}
                    />
                )}
                <CustomText text={i18n.get("", "Por favor tené a mano tu DNI y completá los siguientes pasos.")} />
                <div className="box box-shadow three-step-box">
                    <div className="paso1">
                        <div>
                            <b>
                                <CustomText className="step-start__sub-step" text={i18n.get("", "Paso 1:")} />
                                <br />
                                <CustomText
                                    className="step-start__sub-step-title"
                                    text={i18n.get("", "Permisos y verificación")}
                                />
                            </b>
                            {!onboardingWithInvitation && (
                                <>
                                    <br />

                                    <CustomText text={i18n.get("", "CUIT de empresa")} />
                                    <br />
                                    <CustomText text={i18n.get("", "Tu número de celular y email")} />
                                </>
                            )}
                            <br />
                            {onboardingWithInvitation && (
                                <>
                                    <CustomText text={i18n.get("", "Validación de SMS")} />
                                </>
                            )}
                        </div>
                    </div>
                    <hr className="dotted" />
                    <div className="paso2">
                        <div>
                            <b>
                                <CustomText className="step-start__sub-step" text={i18n.get("", "Paso 2:")} />
                                <br />
                                <CustomText
                                    className="step-start__sub-step-title"
                                    text={i18n.get("", "Datos biométricos")}
                                />
                            </b>
                            <br />
                            <CustomText text={i18n.get("", "Foto de frente y dorso de tu DNI")} />
                            <br />
                            <CustomText text={i18n.get("", "Reconocimiento facial")} />
                        </div>
                    </div>
                    <hr className="dotted" />
                    <div className="paso3">
                        <div>
                            <b>
                                <CustomText className="step-start__sub-step" text={i18n.get("", "Paso 3:")} />
                                <br />
                                <CustomText
                                    className="step-start__sub-step-title"
                                    text={i18n.get("", "Datos personales")}
                                />
                            </b>
                        </div>
                    </div>
                    <hr className="dotted" />
                    <div className="paso4">
                        <div>
                            <b>
                                <CustomText className="step-start__sub-step" text={i18n.get("", "Paso 4:")} />
                                <br />
                                <CustomText
                                    className="step-start__sub-step-title"
                                    text={i18n.get("", "Creación de usuario y contraseña")}
                                />
                            </b>
                        </div>
                    </div>
                </div>

                <div className="form-actions">
                    <Button bsStyle="primary" label="global.begin" loading={false} onClick={onStart} block />
                </div>
            </MainContainer>
        </Fragment>
    );
};

StepStart.propTypes = {
    isMobile: bool.isRequired,
    onboardingWithInvitation: bool.isRequired,
    onboardingWithEnrolledUser: bool.isRequired,
};

const mapStateToProps = (state) => ({
    onboardingWithInvitation: onboardingSelectors.getOnboardingWithInvitation(state),
    onboardingWithEnrolledUser: onboardingSelectors.getOnboardingWithEnrolledUser(state),
});

export default connect(mapStateToProps)(StepStart);
